//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import faqTopicQuery from '~/apollo/queries/faq/faq-topic'

export default {
  mixins: [seo],
  apollo: {
    faqTopic: {
      prefetch: true,
      query: faqTopicQuery,
      variables () {
        return { documentId: this.$route.params.id }
      }
    }
  },
  created () {
    this.seoTitle = 'FAQ'
  }
}
